"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpacing = void 0;
var createSpacing_1 = __importDefault(require("@material-ui/core/styles/createSpacing"));
var createSpacing = function (options) {
    if (options === void 0) { options = 5; }
    return createSpacing_1.default(options);
};
exports.createSpacing = createSpacing;
//# sourceMappingURL=createSpacing.js.map